import { createAuth0Client } from '@auth0/auth0-spa-js';

let auth0Client: any;

export const initAuth0 = async () => {
  auth0Client = await createAuth0Client({
    domain: process.env.REACT_APP_AUTH0_DOMAIN ?? '',
    clientId: process.env.REACT_APP_AUTH0_CLIENT_ID ?? '',
    authorizationParams: {
      redirect_uri: window.location.href,
      prompt: 'select_account',
      connection: 'google-oauth2',
      login_hint: '',
    },
  });
};

export const loginWithGooglePopup = async () => {
  if (!auth0Client) {
    await initAuth0();
  }
  await auth0Client.loginWithPopup();

  const user = await auth0Client.getUser();
  const idToken = await auth0Client.getIdTokenClaims();

  return {
    user,
    token: idToken.__raw,
  };
};
